module.exports = __webpack_public_path__ + "media/images/childcare/patricia@3x-b9bfc727d45487a5b542aa457181367d.jpg";